import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';

// TODO: Could add a linear variant here
export type RadialGradientVariantOptions = 'radial';

export interface RadialGradientProps {
    accentColor: AccentColorOptions;
    children: React.ReactNode;
    disable?: boolean;
    variant?: RadialGradientVariantOptions;
}

export const getRadialGradient = (from: string, to: string): string =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

const Styled = styled.div<{accentColor: AccentColorOptions}>`
    &.radial {
        color: ${(p) => p.theme.palette.common.black};
        background: ${(p) => p.theme.palette.accent[p.accentColor]};
        background: ${(p) =>
            getRadialGradient(
                p.theme.palette.gradient[p.accentColor].from,
                p.theme.palette.gradient[p.accentColor].to
            )};
    }
`;

/**
 * This component will wrap the children components in a new ThemeProvider if
 * a value for `theme` is provided that does not match the value `inherit`.
 *
 */
export const GradientWrapper = (props: RadialGradientProps): JSX.Element => {
    const {accentColor, variant = '', children, disable} = props;

    if (disable) return <>{children}</>;

    return (
        <Styled accentColor={accentColor} className={variant}>
            {children}
        </Styled>
    );
};
